import { render, staticRenderFns } from "./languageKey.vue?vue&type=template&id=2454fac6"
import script from "./languageKey.vue?vue&type=script&lang=js"
export * from "./languageKey.vue?vue&type=script&lang=js"
import style0 from "./languageKey.vue?vue&type=style&index=0&id=2454fac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports